import {TripAction, TripMutation} from "./types";
import axios from "axios";

export default {
    [TripAction.LOAD]({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit(TripMutation.REQUEST);

            let {sortBy, sortDesc, page, itemsPerPage} = payload.options;

            axios.post('/trip', {
                sortBy,
                sortDesc,
                page,
                itemsPerPage,
                filter: payload.filter,
            })
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(TripMutation.SUCCESS, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(TripMutation.ERROR, err.response.data || err);
                    reject(err);
                });
        });
    },
    [TripAction.LOAD_DETAIL]({commit}, id) {
        return new Promise((resolve, reject) => {
            commit(TripMutation.REQUEST);

            axios.get(`/trip/${id}`)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(TripMutation.SUCCESS_DETAIL, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(TripMutation.ERROR, err.response.data || err);
                    reject(err);
                });
        });
    },
    [TripAction.PUBLISH]({commit}, id) {
        return new Promise((resolve, reject) => {
            commit(TripMutation.UPDATE_REQUEST);

            axios.post(`/trip/${id}/publish`)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(TripMutation.SUCCESS_UPDATE, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(TripMutation.ERROR_UPDATE, err.response.data || err);
                    reject(err);
                });
        });
    },
    [TripAction.UNPUBLISH]({commit}, id) {
        return new Promise((resolve, reject) => {
            commit(TripMutation.UPDATE_REQUEST);

            axios.post(`/trip/${id}/unpublish`)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(TripMutation.SUCCESS_UPDATE, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(TripMutation.ERROR_UPDATE, err.response.data || err);
                    reject(err);
                });
        });
    },
    [TripAction.UPDATE]({commit}, trip) {
        return new Promise((resolve, reject) => {
            commit(TripMutation.UPDATE_REQUEST);

            let formData = new FormData();
            if(trip._image) {
                Array.from(trip._image).forEach((image)=>{
                    formData.append('_image[]', image);
                })
            }
            if(trip.downloads) {
                for(let i = 0, l = trip.downloads.length; i < l; i++) {
                    if(
                        // eslint-disable-next-line no-prototype-builtins
                        trip.downloads[i].hasOwnProperty('file') &&
                        trip.downloads[i].file
                    ) {
                        formData.append(`_downloads[${i}][file]`, trip.downloads[i].file);
                    } else {
                        formData.append(`_downloads[${i}][id]`, trip.downloads[i].id);
                    }
                    formData.append(`_downloads[${i}][visibility]`, trip.downloads[i].visibility);
                }
            }
            if(trip.gpx) {
                for(let i = 0, l = trip.gpx.length; i < l; i++) {
                    if(
                        // eslint-disable-next-line no-prototype-builtins
                        trip.gpx[i].hasOwnProperty('file') &&
                        trip.gpx[i].file
                    ) {
                        formData.append(`_gpx[${i}][file]`, trip.gpx[i].file);
                    } else {
                        formData.append(`_gpx[${i}][id]`, trip.gpx[i].id);
                    }
                    formData.append(`_gpx[${i}][visibility]`, trip.gpx[i].visibility);
                }
            }
            for(let i in trip) {
                if(
                    // eslint-disable-next-line no-prototype-builtins
                    !trip.hasOwnProperty(i) ||
                    i === '_image' ||
                    i === 'downloads' ||
                    i === 'gpx'
                ) {
                    continue;
                }

                if(
                    trip[i] !== null &&
                    (
                        typeof trip[i] === 'object' ||
                        Array.isArray(trip[i])
                    )
                ) {
                    formData.append(i, JSON.stringify(trip[i]));
                } else {
                    formData.append(i, trip[i]);
                }

            }

            axios.post(
                `/trip/${trip.id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(TripMutation.SUCCESS_UPDATE, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(TripMutation.ERROR_UPDATE, err.response ? err.response.data : err);
                    reject(err);
                });
        });
    },
    [TripAction.APPLY_TRANSITION]({commit}, transition) {
        return new Promise((resolve, reject) => {
            commit(TripMutation.UPDATE_REQUEST);

            axios.put(
                `/trip/${transition.id}/transition/${transition.name}`,
                transition.payload
            )
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(TripMutation.SUCCESS_UPDATE, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(TripMutation.ERROR_UPDATE, err.response ? err.response.data : err);
                    reject(err);
                });
        });
    },
    [TripAction.SET_ACTIVE_VARIANT]({commit}, variant) {
        if(!variant) {
            commit(TripMutation.SET_ACTIVE_VARIANT, {
                variant: null,
                trip: null,
            });

            return;
        }
        return new Promise((resolve, reject) => {
            commit(TripMutation.REQUEST);

            axios.get(`/trip/${variant.id}`)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(TripMutation.SET_ACTIVE_VARIANT, {
                        variant,
                        trip: data,
                    });
                    resolve(data);
                })
                .catch(err => {
                    commit(TripMutation.ERROR, err.response.data || err);
                    reject(err);
                });
        });
    },
};
